/*
 * @ProjectName: vra
 * @FileName:
 * @PackageName:
 * @Author: Lv Zhuolin
 * @Date: 2021-03-22 11:10:00
 * @LastEditTime: 2021-01-11 13:56:52
 * @LastEditors: Lv Zhuolin
 * @Description:
 * @FilePath: /desktop/src/service/unionService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
import Vue from "vue";
import languages from "../store/modules/languages";
import { getToken } from "@/utils/auth";
/**
 * 福利列表页接口
 */
export function getwelfareData(Info) {
  return request({
    url:
      "/api/v1/member/gifts?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 上架福利接口
 */
export function shelfWelfare(data) {
  return request({
    url: "/api/v1/member/gifts/release/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 新建福利接口
 */
export function postWelfare(formdata) {
  Vue.prototype.$axios.defaults.baseURL = process.env.BASE_API;
  let config = {
    headers: {
      Authorization: "Bearer" + " " + getToken(),
      "Accept-Language": languages.state.currentLang.value,
      "Content-Type": "multipart/form-data"
    }
  };
  return Vue.prototype.$axios.post("/api/v1/member/gifts", formdata, config);
}
/*
 * 编辑福利接口
 */
export function patchWelfare(data) {
  return request({
    url: "/api/v1/member/gifts/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 删除福利接口
 */
export function deleteWelfare(id) {
  return request({
    url: "/api/v1/member/gifts/" + id,
    method: "PUT"
  });
}
/*
 * 获取福利详情
 */
export function getWelfareInfo(id) {
  return request({
    url: "/api/v1/member/gifts/" + id,
    method: "GET"
  });
}

/**
 * 福利人员列表
 */
export function getwelfareUserData(Info) {
  return request({
    url:
      "/api/v1/userGiftsRelation/" +
      Info.id +
      "/list/users?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/**
 * 获取图片地址
 */
export function getImage(id) {
  return request({
    url: "/api/v1/media/autograph?applyId=" + id + "&type=2",
    method: "GET"
  });
}
/**
 * 删除人员
 */
export function deleteWelfareUser(data) {
  return request({
    url: "/api/v1/userGiftsRelation/cancel/users",
    method: "PUT",
    data: data
  });
}
/**
 * 下载模板
 */
export function downloadTem(data) {
  return request({
    url: "/api/v1/userGiftsRelation/excelImport/template",
    method: "GET",
    responseType: "blob",
    data: data
  });
}
/**
 * 下载全部
 */
export function downloadAll(id) {
  return request({
    url: "/api/v1/member/gifts/downloadPdf/" + id,
    method: "GET",
    responseType: "blob"
  });
}
/**
 * 上传文件
 */
export function uploadFile(data) {
  return request({
    url: "/api/v1/userGiftsRelation/excelImport/users",
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: data
  });
}

export function exportUnclaimed(id) {
  request({
    url: "/api/v1/member/gifts/notSigned/download/" + id,
    method: "GET",
    responseType: "blob"
  }).then(res => {
    const fileName = "Unclaimed.xlsx";
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fileName);
    } else {
      const elink = document.createElement("a");
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = window.URL.createObjectURL(res);
      document.body.appendChild(elink);
      elink.click();
      window.URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    }
  })
}



// WEBPACK FOOTER //
// ./src/service/welfareService.js